export default __webpack_public_path__ + "static/media/money.d074d40b.svg";